export enum LocalStorageKeys {
  refRedirect = '@ayRefRedirect',
  oAuthProvider = '@ayOAuthProvider',
  azureTokenExpirationDate = '@ay-pia-web-ACTokenExpirationDate',
  uploadedFilesIds = '@ay-pia-web-uploadedFilesIds',
  timeLastUploadedFile = '@ay-pia-web-timeLastUploadedFile',
  applicationInsightsSessionId = '@ay-pia-web-application-insights-session-id',
  appServicesStatus = '@ay-pia-web-app-services-status',
}
